import React, { useLayoutEffect, useRef, useState } from "react";

/* first `start` aur last `end` chars visible, beech me * */
export const maskMiddle = (value, start = 2, end = 2) => {
    const s = String(value || "");
    if (!s) return "";
    if (s.length <= start + end) return "*".repeat(s.length);
    return (
        s.slice(0, start) +
        "*".repeat(s.length - start - end) +
        s.slice(s.length - end)
    );
};

/*export const maskDob = (value) => {
    const text = String(value || "").trim();
    if (!text) return "";

    // yyyy-mm-dd ya yyyy/mm/dd
    if (/^\d{4}[-/]\d{2}[-/]\d{2}$/.test(text)) {
        return text.replace(/^\d{4}/, "XXXX");
    }
    // dd-mm-yyyy ya dd/mm/yyyy
    if (/^\d{2}[-/]\d{2}[-/]\d{4}$/.test(text)) {
        return text.replace(/\d{4}$/, "XXXX");
    }
    // koi aur format ho to pehla 4-digit number (year) mask kar do
    return text.replace(/\d{4}/, "XXXX");
};*/

export const maskDob = (value) => {
    const text = String(value || "").trim();
    if (!text) return "";

    // yyyy-mm-dd ya yyyy/mm/dd (ISO ke saath time ho to bhi chalega)
    const ymd = text.match(/^(\d{4})[-/](\d{2})[-/](\d{2})/);
    if (ymd) {
        const [, , mm, dd] = ymd;
        return `${dd}-${mm}-XXXX`;
    }

    // dd-mm-yyyy ya dd/mm/yyyy
    const dmy = text.match(/^(\d{2})[-/](\d{2})[-/](\d{4})$/);
    if (dmy) {
        const [, dd, mm] = dmy;
        return `${dd}-${mm}-XXXX`;
    }

    // Koi aur format ho to year (4 digit) mask kar do
    return text.replace(/\d{4}/, "XXXX");
};

export const maskMobile = (v) => maskMiddle(v, 2, 2);
export const maskPan = (v) => maskMiddle(v, 2, 2);
export const maskPassport = (v) => maskMiddle(v, 2, 2);
export const maskPincode = (v) => maskMiddle(v, 2, 2);

// "Rahul Kumar" -> "Ra*** Ku***"
export const maskName = (v) =>
    String(v || "")
        .split(" ")
        .filter(Boolean)
        .map((w) =>
            w.length <= 2
                ? w[0] + "*".repeat(w.length - 1)
                : w.slice(0, 2) + "*".repeat(w.length - 2),
        )
        .join(" ");

// "rahul@gmail.com" -> "ra***@gmail.com"
export const maskEmail = (v) => {
    const s = String(v || "");
    const at = s.indexOf("@");
    if (at < 0) return maskMiddle(s, 2, 0);
    const local = s.slice(0, at);
    return `${local.slice(0, 2)}${"*".repeat(Math.max(local.length - 2, 1))}${s.slice(at)}`;
};

// "Flat 12, MG Road" -> "Fla*********oad"
export const maskAddress = (v) => maskMiddle(v, 3, 3);

/* Input ko kabhi remount/modify nahi karta.
   Blur par real text transparent + upar masked text overlay.
   Focus par overlay hat jata hai, real value dikhti hai. */
export const SecureField = ({ as: Field, maskFn, value, ...rest }) => {
    const [focused, setFocused] = useState(false);
    const [box, setBox] = useState(null);
    const wrapRef = useRef(null);
    const masked = !focused && Boolean(value);

    /*useLayoutEffect(() => {
        if (!masked) return;
        const wrap = wrapRef.current;
        const input = wrap?.querySelector("input");
        if (!input) return;
        const w = wrap.getBoundingClientRect();
        const i = input.getBoundingClientRect();
        const cs = window.getComputedStyle(input);
        setBox({
            top: i.top - w.top,
            left: i.left - w.left,
            width: i.width,
            height: i.height,
            font: cs.font,
            padding: cs.padding,
            letterSpacing: cs.letterSpacing,
            textTransform: cs.textTransform,
        });
    }, [masked, value]);*/

    useLayoutEffect(() => {
        if (!masked) return;
        const wrap = wrapRef.current;
        const input = wrap?.querySelector("input");
        if (!input) return;

        const measure = () => {
            const w = wrap.getBoundingClientRect();
            const i = input.getBoundingClientRect();
            const cs = window.getComputedStyle(input);
            setBox({
                top: i.top - w.top,
                left: i.left - w.left,
                width: i.width,
                height: i.height,
                font: cs.font,
                padding: cs.padding,
                letterSpacing: cs.letterSpacing,
                textTransform: cs.textTransform,
            });
        };

        measure();
        const ro = new ResizeObserver(measure);
        ro.observe(input);
        if (document.fonts?.ready) document.fonts.ready.then(measure);
        return () => ro.disconnect();
    }, [masked, value]);

    return (
        <div
            ref={wrapRef}
            className={masked ? "sf-masked" : ""}
            style={{ position: "relative" }}
            onFocus={() => setFocused(true)}
            onBlur={() => setFocused(false)}
        >
            {/*<style>{`.sf-masked input{color:transparent !important;caret-color:transparent;}`}</style>*/}

            <style>{`
              .sf-masked input {
                color: transparent !important;
                -webkit-text-fill-color: transparent !important;
                caret-color: transparent;
                text-shadow: none !important;
              }
              .sf-masked input:-webkit-autofill {
                -webkit-text-fill-color: transparent !important;
                transition: background-color 99999s ease-in-out 0s;
              }
            `}</style>

            <Field {...rest} value={value} />
            {masked && box && (
                <div
                    aria-hidden="true"
                    style={{
                        position: "absolute",
                        top: box.top,
                        left: box.left,
                        width: box.width,
                        height: box.height,
                        font: box.font,
                        padding: box.padding,
                        letterSpacing: box.letterSpacing,
                        textTransform: box.textTransform,
                        color: "#1f1f1f",
                        display: "flex",
                        alignItems: "center",
                        boxSizing: "border-box",
                        pointerEvents: "none",
                        whiteSpace: "nowrap",
                        overflow: "hidden",
                    }}
                >
                    {maskFn(value)}
                </div>
            )}
        </div>
    );
};